
import {
  ObraPO,
  ObraRegistro,
  ObraServico,
  ObraStatusRegistro,
  ObraRegistroParalisacao,
  ObraDocumentacao,
  ObraDocumentacaoDocumento,
  ObraDetalhePOMIGO,
  ObraDetalhePOMIGOItem,
  ObraRegistroAtraso,
  ObraEscopo
} from '../index';


export class Obra {
  "id";
  "ordemDeVenda";
  "situacao";
  "dataDeAceiteDaDemanda";
  "dataDeConclusao";
  "dataDaCriacaoDaDemanda";
  "site";
  "situacaoDaIntegracao";
  "situacaoDaDemanda";
  "gestorDeImplantacao";
  "solicitanteDaDemanda";
  "cliente";
  "regional";
  "DataCadastro";
  "motivoDoCancelamentoDaObra";
  "dataDeConclusaoReportado";
  "atualizarEscopos";
  "sinergia";
  "executor";
  "dataDoFimDaObra";
  "permitirRecebimentoDoMaterialSemReportDeRecebimentoDoCampo";
  "expurgo";
  "modoAdministrador";
  "alterouADataAtribuidaPeloGI";
  "listaDeRegistros";
  "solicitacoesDeEscopo";
  "tipoDeDemanda";
  "cleanUps";
  "dataDeRecebimentoDoSiteReportado";
  "dataDeConclusaoPrevistaAceita";
  "percentualAuditado";
  "resultadoPercentual";
  "atrasosAbonadosDias";
  "statusInformarNumerosPOs";
  "motivoDoNaoRecebimentoDoSite";
  "motivosParaDiscordarDoPlanejamento";
  "divergenciasEntreOQueFoiRecebidoEANF";
  "dataEHoraDoPedidoDeAceite";
  "pendenciaDeFaturamento";
  "motivosParaIniciarSemPO";
  "motivoParaNaoAutorizarSemOPO";
  "materialRecebidoESuficienteParaExecutarAObra";
  "cancelarSolicitacaoDaObra";
  "statusSolicitarRC";
  "possuiNovaDataDeRecebimento";
  "materialRecebidoDeAcordoComANotaFiscal";
  "recebeuOSite";
  "statusAutorizarInicioDaObraSemPO";
  "aceiteDoFornecedor";
  "motivoNegativaFornecedor";
  "recebeuPDFsDasPOs";
  "existeAlgumaPendencia";
  "jaPossuiNumerosDasPOs";
  "materiaisNaoRecebidos";
  "planilhaDeSolicitacaoDePoRc";
  "autorizarInicioSemPO";
  "novaDataParaRecebimento";
  "motivoDoCancelamentoDeSolicitacaoDaObra";
  "solicitarNovamenteOInicioDaObraSemPO";
  "statusConfirmarRecebimentoDePO";
  "concordarComOReplanejamento";
  "dataDeSolicitacaoDeRC";
  "statusSolicitarInformarPO";
  "statusAceiteFormal";
  "motivoParaAutorizarSemOPO";
  "dataDeAcessoAoSite";
  "dataFimDaRetiradaDePendencia";
  "qualidadeSite";
  "novaDataDeFimDaObraPlanejado";
  "supervisorEricssonIndividuo";
  "supervisorEricsson";
  "membrosDaEquipeAvaliada";
  "integracaoValidadaPorProblemaDeCliente";
  "dataDeSolicitacaoDaPO";
  "dataDaDocumentacaoComPdiAprovadaCompleta";
  "resultadoAuditado";
  "statusRSA";
  "dataDaDocumentacaoAprovadaCompleta";
  "fornecedorVendor";
  "fornecedorNome";
  "justificativaDoEscopo";
  "justificativaDeLiberacaoDoPagamento";
  "dataDeConclusaoDaIntegracao";
  "escopoAdicionalRecuperado";
  "novoSupervisorASPIndividuo";
  "motivoDaRejeicaoDaDemanda";
  "dataDeInicioEntregaPlanejado";
  "reportDiarioDeInstalacaoPendente";
  "tempoDeParalisacaoDias";
  "dataDeInicioAtribuidaPeloGI";
  "novaDataDeInicioEntregaPlanejado";
  "obraRFP";
  "supervisorASPIndividuo";
  "logDeIntegracao";
  "slaPadraoDoEscopoDias";
  "atv";
  "dataDeFimAtribuidaPeloGI";
  "novoSupervisorASP";
  "dataDoAceiteDaObra";
  "supervisorASP";
  "dataDeInicioDeQuarentena";
  "listaDePos";
  "tratativasInternas";
  "justificativaDoReplanejamento";
  "permiteSolicitacaoDeEscopoExtra";
  "precoDaObra";
  "dataDeFimDeQuarentena";
  "escopoTipoDoEscopo";
  "escopoSla";
  "escopoNome";
  "escopoTypeSite";
  "escopoSlaDaRegional";
  "boqNome";
  "dataDeInicioDaRetiradaDePendencia";
  "gerenteGeralASP";
  "resultadoBonusMulta";
  "documentacaoPDIDaObra";
  "recebimentoDosMateriaisNRO";
  "dataDeFimDaObraPlanejado";
  "dataFimProcessoImplantacao";
  "dataDeConclusaoDaValidacaoDeQualidade";
  "distribuicaoDeDemandasID";
  "prolog";
  "novaEquipe";
  "situacaoDasPOs";
  "diasDeAtrasoTotalReal";
  "novaDataDeClonclusaoSLAPadrao";
  "justificativaDoEscopoAdicional";
  "dataDeConclusaoEstimada";
  "equipe";
  "dataDoFimDeInstalacao";
  "Escopo_tipoDoEscopo";
  "Escopo_sla";
  "Escopo_nome";
  "Escopo_typeSite";
  "Escopo_slaDaRegional";
  "EscopoRecuperadoSH_tipoDoEscopo";
  "EscopoRecuperadoSH_sla";
  "EscopoRecuperadoSH_nome";
  "EscopoRecuperadoSH_typeSite";
  "EscopoRecuperadoSH_slaDaRegional";
  "lastUpdateDate";
  "dataDeBaselineIntegracao";
  "dataDeBaselineIntegracaoRegistros_datasRegistros";
  "dataDeIntegracaoPlanejado";
  "dataDeSiteAptoParaAceitacaoBaseline";
  "dataDeSiteAptoParaAceitacaoPlanejado";
  "dataDeSiteAptoParaAceitacaoReal";
  "dataDeAceitacaoReal";
  "ofensorAtual";
  "dataDeTX";
  "dataDeACKHW";
  "dataDeFAMHABILITADA";
  "dataDeINFRA";
  "reuso";
  "responsavelDaObra";
  "rfp";
  "fAMDataDePostagem";
  "fAMDataDeValidacao";
  "fAM";
  "escopoCW";
  "motivoDoReplanejamento";
  "intervencaoClaro";
  "conclusaoInstalacaoAprovada";
  "obraChangeLog";
  "justificativaAgingDeInstalacao";
  "rsa_controleRsa";
  "rsa_fluxoRSA";
  "rsa_statusRsa";
  "rsa_submeterParaRsa";
  "rsa_validacaoDeQualidadeRsa";
  "dataDeIntegracaoReal";
  "numero";
  "tipoDeObra";
  POs;
  Registros;
  Servicos;
  RegistrosStatus;
  RegistrosParalisacao;
  Documentacao;
  Documentos;
  POsMigo;
  POMigoItens;
  RegistrosAtrasos;
  Escopos;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Obra`.
   */
  static getModelName() {
    return "Obra";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Obra for dynamic purposes.
  **/
  static factory(data) {
    return new Obra(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'Obra',
      plural: 'Obras',
      path: 'Obras',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "ordemDeVenda": {
          name: 'ordemDeVenda',
          type: 'string'
        },
        "situacao": {
          name: 'situacao',
          type: 'string'
        },
        "dataDeAceiteDaDemanda": {
          name: 'dataDeAceiteDaDemanda',
          type: 'Date'
        },
        "dataDeConclusao": {
          name: 'dataDeConclusao',
          type: 'Date'
        },
        "dataDaCriacaoDaDemanda": {
          name: 'dataDaCriacaoDaDemanda',
          type: 'Date'
        },
        "site": {
          name: 'site',
          type: 'string'
        },
        "situacaoDaIntegracao": {
          name: 'situacaoDaIntegracao',
          type: 'string'
        },
        "situacaoDaDemanda": {
          name: 'situacaoDaDemanda',
          type: 'string'
        },
        "gestorDeImplantacao": {
          name: 'gestorDeImplantacao',
          type: 'string'
        },
        "solicitanteDaDemanda": {
          name: 'solicitanteDaDemanda',
          type: 'string'
        },
        "cliente": {
          name: 'cliente',
          type: 'string'
        },
        "regional": {
          name: 'regional',
          type: 'string'
        },
        "DataCadastro": {
          name: 'DataCadastro',
          type: 'Date'
        },
        "motivoDoCancelamentoDaObra": {
          name: 'motivoDoCancelamentoDaObra',
          type: 'string'
        },
        "dataDeConclusaoReportado": {
          name: 'dataDeConclusaoReportado',
          type: 'Date'
        },
        "atualizarEscopos": {
          name: 'atualizarEscopos',
          type: 'string'
        },
        "sinergia": {
          name: 'sinergia',
          type: 'string'
        },
        "executor": {
          name: 'executor',
          type: 'string'
        },
        "dataDoFimDaObra": {
          name: 'dataDoFimDaObra',
          type: 'Date'
        },
        "permitirRecebimentoDoMaterialSemReportDeRecebimentoDoCampo": {
          name: 'permitirRecebimentoDoMaterialSemReportDeRecebimentoDoCampo',
          type: 'string'
        },
        "expurgo": {
          name: 'expurgo',
          type: 'string'
        },
        "modoAdministrador": {
          name: 'modoAdministrador',
          type: 'string'
        },
        "alterouADataAtribuidaPeloGI": {
          name: 'alterouADataAtribuidaPeloGI',
          type: 'string'
        },
        "listaDeRegistros": {
          name: 'listaDeRegistros',
          type: 'string'
        },
        "solicitacoesDeEscopo": {
          name: 'solicitacoesDeEscopo',
          type: 'string'
        },
        "tipoDeDemanda": {
          name: 'tipoDeDemanda',
          type: 'string'
        },
        "cleanUps": {
          name: 'cleanUps',
          type: 'string'
        },
        "dataDeRecebimentoDoSiteReportado": {
          name: 'dataDeRecebimentoDoSiteReportado',
          type: 'Date'
        },
        "dataDeConclusaoPrevistaAceita": {
          name: 'dataDeConclusaoPrevistaAceita',
          type: 'Date'
        },
        "percentualAuditado": {
          name: 'percentualAuditado',
          type: 'string'
        },
        "resultadoPercentual": {
          name: 'resultadoPercentual',
          type: 'string'
        },
        "atrasosAbonadosDias": {
          name: 'atrasosAbonadosDias',
          type: 'number'
        },
        "statusInformarNumerosPOs": {
          name: 'statusInformarNumerosPOs',
          type: 'string'
        },
        "motivoDoNaoRecebimentoDoSite": {
          name: 'motivoDoNaoRecebimentoDoSite',
          type: 'string'
        },
        "motivosParaDiscordarDoPlanejamento": {
          name: 'motivosParaDiscordarDoPlanejamento',
          type: 'string'
        },
        "divergenciasEntreOQueFoiRecebidoEANF": {
          name: 'divergenciasEntreOQueFoiRecebidoEANF',
          type: 'string'
        },
        "dataEHoraDoPedidoDeAceite": {
          name: 'dataEHoraDoPedidoDeAceite',
          type: 'Date'
        },
        "pendenciaDeFaturamento": {
          name: 'pendenciaDeFaturamento',
          type: 'string'
        },
        "motivosParaIniciarSemPO": {
          name: 'motivosParaIniciarSemPO',
          type: 'string'
        },
        "motivoParaNaoAutorizarSemOPO": {
          name: 'motivoParaNaoAutorizarSemOPO',
          type: 'string'
        },
        "materialRecebidoESuficienteParaExecutarAObra": {
          name: 'materialRecebidoESuficienteParaExecutarAObra',
          type: 'string'
        },
        "cancelarSolicitacaoDaObra": {
          name: 'cancelarSolicitacaoDaObra',
          type: 'string'
        },
        "statusSolicitarRC": {
          name: 'statusSolicitarRC',
          type: 'string'
        },
        "possuiNovaDataDeRecebimento": {
          name: 'possuiNovaDataDeRecebimento',
          type: 'string'
        },
        "materialRecebidoDeAcordoComANotaFiscal": {
          name: 'materialRecebidoDeAcordoComANotaFiscal',
          type: 'string'
        },
        "recebeuOSite": {
          name: 'recebeuOSite',
          type: 'string'
        },
        "statusAutorizarInicioDaObraSemPO": {
          name: 'statusAutorizarInicioDaObraSemPO',
          type: 'string'
        },
        "aceiteDoFornecedor": {
          name: 'aceiteDoFornecedor',
          type: 'string'
        },
        "motivoNegativaFornecedor": {
          name: 'motivoNegativaFornecedor',
          type: 'string'
        },
        "recebeuPDFsDasPOs": {
          name: 'recebeuPDFsDasPOs',
          type: 'string'
        },
        "existeAlgumaPendencia": {
          name: 'existeAlgumaPendencia',
          type: 'string'
        },
        "jaPossuiNumerosDasPOs": {
          name: 'jaPossuiNumerosDasPOs',
          type: 'string'
        },
        "materiaisNaoRecebidos": {
          name: 'materiaisNaoRecebidos',
          type: 'string'
        },
        "planilhaDeSolicitacaoDePoRc": {
          name: 'planilhaDeSolicitacaoDePoRc',
          type: 'string'
        },
        "autorizarInicioSemPO": {
          name: 'autorizarInicioSemPO',
          type: 'string'
        },
        "novaDataParaRecebimento": {
          name: 'novaDataParaRecebimento',
          type: 'Date'
        },
        "motivoDoCancelamentoDeSolicitacaoDaObra": {
          name: 'motivoDoCancelamentoDeSolicitacaoDaObra',
          type: 'string'
        },
        "solicitarNovamenteOInicioDaObraSemPO": {
          name: 'solicitarNovamenteOInicioDaObraSemPO',
          type: 'string'
        },
        "statusConfirmarRecebimentoDePO": {
          name: 'statusConfirmarRecebimentoDePO',
          type: 'string'
        },
        "concordarComOReplanejamento": {
          name: 'concordarComOReplanejamento',
          type: 'string'
        },
        "dataDeSolicitacaoDeRC": {
          name: 'dataDeSolicitacaoDeRC',
          type: 'Date'
        },
        "statusSolicitarInformarPO": {
          name: 'statusSolicitarInformarPO',
          type: 'string'
        },
        "statusAceiteFormal": {
          name: 'statusAceiteFormal',
          type: 'string'
        },
        "motivoParaAutorizarSemOPO": {
          name: 'motivoParaAutorizarSemOPO',
          type: 'string'
        },
        "dataDeAcessoAoSite": {
          name: 'dataDeAcessoAoSite',
          type: 'Date'
        },
        "dataFimDaRetiradaDePendencia": {
          name: 'dataFimDaRetiradaDePendencia',
          type: 'Date'
        },
        "qualidadeSite": {
          name: 'qualidadeSite',
          type: 'string'
        },
        "novaDataDeFimDaObraPlanejado": {
          name: 'novaDataDeFimDaObraPlanejado',
          type: 'Date'
        },
        "supervisorEricssonIndividuo": {
          name: 'supervisorEricssonIndividuo',
          type: 'string'
        },
        "supervisorEricsson": {
          name: 'supervisorEricsson',
          type: 'string'
        },
        "membrosDaEquipeAvaliada": {
          name: 'membrosDaEquipeAvaliada',
          type: 'string'
        },
        "integracaoValidadaPorProblemaDeCliente": {
          name: 'integracaoValidadaPorProblemaDeCliente',
          type: 'string'
        },
        "dataDeSolicitacaoDaPO": {
          name: 'dataDeSolicitacaoDaPO',
          type: 'Date'
        },
        "dataDaDocumentacaoComPdiAprovadaCompleta": {
          name: 'dataDaDocumentacaoComPdiAprovadaCompleta',
          type: 'Date'
        },
        "resultadoAuditado": {
          name: 'resultadoAuditado',
          type: 'string'
        },
        "statusRSA": {
          name: 'statusRSA',
          type: 'string'
        },
        "dataDaDocumentacaoAprovadaCompleta": {
          name: 'dataDaDocumentacaoAprovadaCompleta',
          type: 'Date'
        },
        "fornecedorVendor": {
          name: 'fornecedorVendor',
          type: 'string'
        },
        "fornecedorNome": {
          name: 'fornecedorNome',
          type: 'string'
        },
        "justificativaDoEscopo": {
          name: 'justificativaDoEscopo',
          type: 'string'
        },
        "justificativaDeLiberacaoDoPagamento": {
          name: 'justificativaDeLiberacaoDoPagamento',
          type: 'string'
        },
        "dataDeConclusaoDaIntegracao": {
          name: 'dataDeConclusaoDaIntegracao',
          type: 'Date'
        },
        "escopoAdicionalRecuperado": {
          name: 'escopoAdicionalRecuperado',
          type: 'string'
        },
        "novoSupervisorASPIndividuo": {
          name: 'novoSupervisorASPIndividuo',
          type: 'string'
        },
        "motivoDaRejeicaoDaDemanda": {
          name: 'motivoDaRejeicaoDaDemanda',
          type: 'string'
        },
        "dataDeInicioEntregaPlanejado": {
          name: 'dataDeInicioEntregaPlanejado',
          type: 'Date'
        },
        "reportDiarioDeInstalacaoPendente": {
          name: 'reportDiarioDeInstalacaoPendente',
          type: 'string'
        },
        "tempoDeParalisacaoDias": {
          name: 'tempoDeParalisacaoDias',
          type: 'number'
        },
        "dataDeInicioAtribuidaPeloGI": {
          name: 'dataDeInicioAtribuidaPeloGI',
          type: 'Date'
        },
        "novaDataDeInicioEntregaPlanejado": {
          name: 'novaDataDeInicioEntregaPlanejado',
          type: 'Date'
        },
        "obraRFP": {
          name: 'obraRFP',
          type: 'string'
        },
        "supervisorASPIndividuo": {
          name: 'supervisorASPIndividuo',
          type: 'string'
        },
        "logDeIntegracao": {
          name: 'logDeIntegracao',
          type: 'string'
        },
        "slaPadraoDoEscopoDias": {
          name: 'slaPadraoDoEscopoDias',
          type: 'number'
        },
        "atv": {
          name: 'atv',
          type: 'string'
        },
        "dataDeFimAtribuidaPeloGI": {
          name: 'dataDeFimAtribuidaPeloGI',
          type: 'Date'
        },
        "novoSupervisorASP": {
          name: 'novoSupervisorASP',
          type: 'string'
        },
        "dataDoAceiteDaObra": {
          name: 'dataDoAceiteDaObra',
          type: 'Date'
        },
        "supervisorASP": {
          name: 'supervisorASP',
          type: 'string'
        },
        "dataDeInicioDeQuarentena": {
          name: 'dataDeInicioDeQuarentena',
          type: 'Date'
        },
        "listaDePos": {
          name: 'listaDePos',
          type: 'string'
        },
        "tratativasInternas": {
          name: 'tratativasInternas',
          type: 'string'
        },
        "justificativaDoReplanejamento": {
          name: 'justificativaDoReplanejamento',
          type: 'string'
        },
        "permiteSolicitacaoDeEscopoExtra": {
          name: 'permiteSolicitacaoDeEscopoExtra',
          type: 'string'
        },
        "precoDaObra": {
          name: 'precoDaObra',
          type: 'number'
        },
        "dataDeFimDeQuarentena": {
          name: 'dataDeFimDeQuarentena',
          type: 'Date'
        },
        "escopoTipoDoEscopo": {
          name: 'escopoTipoDoEscopo',
          type: 'string'
        },
        "escopoSla": {
          name: 'escopoSla',
          type: 'number'
        },
        "escopoNome": {
          name: 'escopoNome',
          type: 'string'
        },
        "escopoTypeSite": {
          name: 'escopoTypeSite',
          type: 'string'
        },
        "escopoSlaDaRegional": {
          name: 'escopoSlaDaRegional',
          type: 'number'
        },
        "boqNome": {
          name: 'boqNome',
          type: 'string'
        },
        "dataDeInicioDaRetiradaDePendencia": {
          name: 'dataDeInicioDaRetiradaDePendencia',
          type: 'Date'
        },
        "gerenteGeralASP": {
          name: 'gerenteGeralASP',
          type: 'string'
        },
        "resultadoBonusMulta": {
          name: 'resultadoBonusMulta',
          type: 'string'
        },
        "documentacaoPDIDaObra": {
          name: 'documentacaoPDIDaObra',
          type: 'string'
        },
        "recebimentoDosMateriaisNRO": {
          name: 'recebimentoDosMateriaisNRO',
          type: 'string'
        },
        "dataDeFimDaObraPlanejado": {
          name: 'dataDeFimDaObraPlanejado',
          type: 'Date'
        },
        "dataFimProcessoImplantacao": {
          name: 'dataFimProcessoImplantacao',
          type: 'Date'
        },
        "dataDeConclusaoDaValidacaoDeQualidade": {
          name: 'dataDeConclusaoDaValidacaoDeQualidade',
          type: 'Date'
        },
        "distribuicaoDeDemandasID": {
          name: 'distribuicaoDeDemandasID',
          type: 'string'
        },
        "prolog": {
          name: 'prolog',
          type: 'string'
        },
        "novaEquipe": {
          name: 'novaEquipe',
          type: 'string'
        },
        "situacaoDasPOs": {
          name: 'situacaoDasPOs',
          type: 'string'
        },
        "diasDeAtrasoTotalReal": {
          name: 'diasDeAtrasoTotalReal',
          type: 'number'
        },
        "novaDataDeClonclusaoSLAPadrao": {
          name: 'novaDataDeClonclusaoSLAPadrao',
          type: 'Date'
        },
        "justificativaDoEscopoAdicional": {
          name: 'justificativaDoEscopoAdicional',
          type: 'string'
        },
        "dataDeConclusaoEstimada": {
          name: 'dataDeConclusaoEstimada',
          type: 'Date'
        },
        "equipe": {
          name: 'equipe',
          type: 'string'
        },
        "dataDoFimDeInstalacao": {
          name: 'dataDoFimDeInstalacao',
          type: 'Date'
        },
        "Escopo_tipoDoEscopo": {
          name: 'Escopo_tipoDoEscopo',
          type: 'string'
        },
        "Escopo_sla": {
          name: 'Escopo_sla',
          type: 'string'
        },
        "Escopo_nome": {
          name: 'Escopo_nome',
          type: 'string'
        },
        "Escopo_typeSite": {
          name: 'Escopo_typeSite',
          type: 'string'
        },
        "Escopo_slaDaRegional": {
          name: 'Escopo_slaDaRegional',
          type: 'string'
        },
        "EscopoRecuperadoSH_tipoDoEscopo": {
          name: 'EscopoRecuperadoSH_tipoDoEscopo',
          type: 'string'
        },
        "EscopoRecuperadoSH_sla": {
          name: 'EscopoRecuperadoSH_sla',
          type: 'string'
        },
        "EscopoRecuperadoSH_nome": {
          name: 'EscopoRecuperadoSH_nome',
          type: 'string'
        },
        "EscopoRecuperadoSH_typeSite": {
          name: 'EscopoRecuperadoSH_typeSite',
          type: 'string'
        },
        "EscopoRecuperadoSH_slaDaRegional": {
          name: 'EscopoRecuperadoSH_slaDaRegional',
          type: 'string'
        },
        "lastUpdateDate": {
          name: 'lastUpdateDate',
          type: 'Date'
        },
        "dataDeBaselineIntegracao": {
          name: 'dataDeBaselineIntegracao',
          type: 'Date'
        },
        "dataDeBaselineIntegracaoRegistros_datasRegistros": {
          name: 'dataDeBaselineIntegracaoRegistros_datasRegistros',
          type: 'string'
        },
        "dataDeIntegracaoPlanejado": {
          name: 'dataDeIntegracaoPlanejado',
          type: 'Date'
        },
        "dataDeSiteAptoParaAceitacaoBaseline": {
          name: 'dataDeSiteAptoParaAceitacaoBaseline',
          type: 'Date'
        },
        "dataDeSiteAptoParaAceitacaoPlanejado": {
          name: 'dataDeSiteAptoParaAceitacaoPlanejado',
          type: 'Date'
        },
        "dataDeSiteAptoParaAceitacaoReal": {
          name: 'dataDeSiteAptoParaAceitacaoReal',
          type: 'Date'
        },
        "dataDeAceitacaoReal": {
          name: 'dataDeAceitacaoReal',
          type: 'Date'
        },
        "ofensorAtual": {
          name: 'ofensorAtual',
          type: 'string'
        },
        "dataDeTX": {
          name: 'dataDeTX',
          type: 'Date'
        },
        "dataDeACKHW": {
          name: 'dataDeACKHW',
          type: 'Date'
        },
        "dataDeFAMHABILITADA": {
          name: 'dataDeFAMHABILITADA',
          type: 'Date'
        },
        "dataDeINFRA": {
          name: 'dataDeINFRA',
          type: 'Date'
        },
        "reuso": {
          name: 'reuso',
          type: 'string'
        },
        "responsavelDaObra": {
          name: 'responsavelDaObra',
          type: 'string'
        },
        "rfp": {
          name: 'rfp',
          type: 'string'
        },
        "fAMDataDePostagem": {
          name: 'fAMDataDePostagem',
          type: 'Date'
        },
        "fAMDataDeValidacao": {
          name: 'fAMDataDeValidacao',
          type: 'Date'
        },
        "fAM": {
          name: 'fAM',
          type: 'string'
        },
        "escopoCW": {
          name: 'escopoCW',
          type: 'string'
        },
        "motivoDoReplanejamento": {
          name: 'motivoDoReplanejamento',
          type: 'string'
        },
        "intervencaoClaro": {
          name: 'intervencaoClaro',
          type: 'string'
        },
        "conclusaoInstalacaoAprovada": {
          name: 'conclusaoInstalacaoAprovada',
          type: 'string'
        },
        "obraChangeLog": {
          name: 'obraChangeLog',
          type: 'string'
        },
        "justificativaAgingDeInstalacao": {
          name: 'justificativaAgingDeInstalacao',
          type: 'string'
        },
        "rsa_controleRsa": {
          name: 'rsa_controleRsa',
          type: 'string'
        },
        "rsa_fluxoRSA": {
          name: 'rsa_fluxoRSA',
          type: 'string'
        },
        "rsa_statusRsa": {
          name: 'rsa_statusRsa',
          type: 'string'
        },
        "rsa_submeterParaRsa": {
          name: 'rsa_submeterParaRsa',
          type: 'string'
        },
        "rsa_validacaoDeQualidadeRsa": {
          name: 'rsa_validacaoDeQualidadeRsa',
          type: 'string'
        },
        "dataDeIntegracaoReal": {
          name: 'dataDeIntegracaoReal',
          type: 'Date'
        },
        "numero": {
          name: 'numero',
          type: 'string'
        },
        "tipoDeObra": {
          name: 'tipoDeObra',
          type: 'string'
        },
      },
      relations: {
        POs: {
          name: 'POs',
          type: 'ObraPO[]',
          model: 'ObraPO'
        },
        Registros: {
          name: 'Registros',
          type: 'ObraRegistro[]',
          model: 'ObraRegistro'
        },
        Servicos: {
          name: 'Servicos',
          type: 'ObraServico[]',
          model: 'ObraServico'
        },
        RegistrosStatus: {
          name: 'RegistrosStatus',
          type: 'ObraStatusRegistro[]',
          model: 'ObraStatusRegistro'
        },
        RegistrosParalisacao: {
          name: 'RegistrosParalisacao',
          type: 'ObraRegistroParalisacao[]',
          model: 'ObraRegistroParalisacao'
        },
        Documentacao: {
          name: 'Documentacao',
          type: 'ObraDocumentacao[]',
          model: 'ObraDocumentacao'
        },
        Documentos: {
          name: 'Documentos',
          type: 'ObraDocumentacaoDocumento[]',
          model: 'ObraDocumentacaoDocumento'
        },
        POsMigo: {
          name: 'POsMigo',
          type: 'ObraDetalhePOMIGO[]',
          model: 'ObraDetalhePOMIGO'
        },
        POMigoItens: {
          name: 'POMigoItens',
          type: 'ObraDetalhePOMIGOItem[]',
          model: 'ObraDetalhePOMIGOItem'
        },
        RegistrosAtrasos: {
          name: 'RegistrosAtrasos',
          type: 'ObraRegistroAtraso[]',
          model: 'ObraRegistroAtraso'
        },
        Escopos: {
          name: 'Escopos',
          type: 'ObraEscopo[]',
          model: 'ObraEscopo'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/Obra.js